import { useSuspenseQuery } from '@tanstack/react-query';
import { queries } from '../../api/queries.js';
import type { Me } from '../../api/types.js';

/**
 * The signed-in person. Only valid under the `_app` layout, which is what turns the refusals
 * into screens — so everything below it can treat the answer as present instead of checking
 * for a null it can do nothing about.
 */
export function useMe(): Me {
  const { data } = useSuspenseQuery(queries.me());
  if (!data.ok) {
    // Unreachable through the router: `_app` renders NoAccessScreen instead of an Outlet.
    // Throwing beats a fabricated empty person, which would read as "signed in as nobody".
    throw new Error(`not signed in (${data.reason})`);
  }
  return data.me;
}
